import type * as React from "react";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "../../components/ui/empty";
import { Icon } from "../../components/ui/icon";
import type { DataTableEmptyProps } from "./data-table-types";

/**
 * Empty state component for DataTable.
 * Displays when there are no rows to show.
 */
export function DataTableEmpty({
  title,
  description,
  media,
  action,
  message = "No results.",
  children,
}: DataTableEmptyProps): React.ReactElement {
  return (
    <Empty className="flex-1">
      {children ?? (
        <>
          {/* `circle` is the quiet decorative well: a table's empty state sits
              inside a panel that already owns card chrome, so the `icon`
              card-chip art would paint a competing card-colored box on it. */}
          <EmptyMedia variant="circle">
            {media ?? <Icon name="table" size="2xl" color="muted" />}
          </EmptyMedia>
          <EmptyHeader>
            {title ? <EmptyTitle>{title}</EmptyTitle> : null}
            <EmptyDescription>{description ?? message}</EmptyDescription>
          </EmptyHeader>
          {action ? <EmptyContent>{action}</EmptyContent> : null}
        </>
      )}
    </Empty>
  );
}
